import { useMutation } from '@tanstack/react-query';
import { submitContactForm, type ContactFormData } from '../api';
import toast from 'react-hot-toast';

export const useContactMutation = () => {
  return useMutation({
    mutationFn: (data: ContactFormData) => submitContactForm(data),
    onSuccess: (response) => {
      toast.success(
        response.message ||
          'Your message has been sent successfully! We will get back to you soon.',
        {
          duration: 5000,
        },
      );
    },
    onError: (
      error: Error & { response?: { data?: { message?: string } } },
    ) => {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        'Failed to send your message. Please try again later.';

      toast.error(errorMessage, {
        duration: 5000,
      });
    },
  });
};
